import { render } from "./AccessRequestDrilldownDialog.vue?vue&type=template&id=c34af90a&ts=true"
import script from "./AccessRequestDrilldownDialog.vue?vue&type=script&lang=ts"
export * from "./AccessRequestDrilldownDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__